import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DocumentSubCategoryStoreActions,
  DocumentSubCategoryStoreSelectors,
  DocumentSubCategoryStoreReducer,
} from './index';
import { DocumentSubCategoryDto } from '@cradua/data';

@Injectable()
export class DocumentSubCategoryFacade {
  constructor(
    private store: Store<
      DocumentSubCategoryStoreReducer.DocumentSubCategoryPartialState
    >
  ) {}

  documentSubCategoryRecord$ = this.store.select(
    DocumentSubCategoryStoreSelectors.getSelected
  );
  documentSubCategoryRecordError$ = this.store.select(
    DocumentSubCategoryStoreSelectors.getDocumentSubCategoryError
  );

  getselected() {
    return this.store.select(DocumentSubCategoryStoreSelectors.getSelected);
  }

  get isLoadingDocumentSubCategory() {
    this.store.dispatch(
      DocumentSubCategoryStoreActions.loadDocumentSubCategory()
    );
    return this.store.select(
      DocumentSubCategoryStoreSelectors.loadingDocumentSubCategory
    );
  }

  get loadDocumentSubCategory() {
    this.store.dispatch(
      DocumentSubCategoryStoreActions.loadDocumentSubCategory()
    );
    return this.store.select(
      DocumentSubCategoryStoreSelectors.getAllDocumentSubCategory
    );
  }

  addDocumentSubCategory(newDocumentSubCategory: DocumentSubCategoryDto[]) {
    this.store.dispatch(
      DocumentSubCategoryStoreActions.addDocumentSubCategory({
        newDocumentSubCategory,
      })
    );
  }

  updateDocumentSubCategory(
    updateDocumentSubCategory: DocumentSubCategoryDto[]
  ) {
    this.store.dispatch(
      DocumentSubCategoryStoreActions.updateDocumentSubCategory({
        updateDocumentSubCategory,
      })
    );
  }

  removeDocumentSubCategory(ids: string[]) {
    this.store.dispatch(
      DocumentSubCategoryStoreActions.removeDocumentSubCategory({ ids })
    );
  }
}
